module.exports = __webpack_public_path__ + "img/35757-043.24ca739e.jpg";